import React, {useEffect, useRef, useState} from 'react';
import {Player} from 'bitmovin-player';
import {UIFactory} from 'bitmovin-player/bitmovinplayer-ui';
import 'bitmovin-player/bitmovinplayer-ui.css';
import './styles.css'; // Import your CSS file
import convertBase64toBlob from 'app/utils/ConvertBase64ToBlob';
import * as CommunicationActions from '../../actions/CommunicationActions'
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Modal } from 'antd';
import * as CotplayHubActions from '../../actions/CotplayHubActions';



function MediaPlayer(props) {

  const { confirm } = Modal;
  const [player, setPlayer] = useState(null);

  const playerConfig = {
    key: process.env.REACT_APP_BITMOVIN_PLAYER,
    ui: {
      playbackSpeedSelectionEnabled: false
    }
  };

  const dispatch = useDispatch();
  let IsfirstPlay = true;
  const [showPlayer, setShowPlayer] = useState(false);

  const playerProgressive = {
    progressive: props.videoData.urlStream,
    poster: convertBase64toBlob(props.videoData.thumbnail, 'image/png'),
    options:{
      startOffset: props.videoData.timeVideo,
      startOffsetTimelineReference: 0
    },
    muted:false,
    autoplay:false
  };

  const playerHlsDash = {
    hls: props.videoData.hlsStream,
    dash: props.videoData.dashStream,
    poster: convertBase64toBlob(props.videoData.thumbnail, 'image/png'),
    options:{
      startOffset: props.videoData.timeVideo,
      startOffsetTimelineReference: 0
    },
    muted:false,
    autoplay:false

  };


  const playerDiv = useRef();

  useEffect(() => {
    function setupPlayer() {
      let config = null;
      if((props.videoData.dashStream !== null && props.videoData.hlsStream !== null) && 
      (props.videoData.dashStream !== '' && props.videoData.hlsStream !== '')){
        config = playerHlsDash;
      }else{
        config = playerProgressive;
      }

      const playerInstance = new Player(playerDiv.current, playerConfig);
      UIFactory.buildDefaultUI(playerInstance);
      playerInstance.load(config).then(() => {
        setPlayer(playerInstance)
        setShowPlayer(true)
        //Sets the HTML attribute "disabled" for the <button> so the link is no longer clickable  
        if(document.querySelector("button.bmpui-ui-watermark") !== null)
        document.querySelector("button.bmpui-ui-watermark").setAttribute("disabled", "disabled");

        if(document.querySelector(".bmpui-ui-playbackspeedselectbox") !== null){
          let padreSuperior=document.querySelector(".bmpui-ui-playbackspeedselectbox").parentNode.parentNode;
          padreSuperior.setAttribute("Hidden", true)
        }
        //document.querySelector("button.bmpui-ui-watermark").dataset.url = "https://appsdev.cotemar.com.mx/EncuestasCotemar/login";

        console.log('Successfully loaded source');
        
      }, (ex) => {
        console.log(props)
        console.log(ex);
      });

      //document.getElementsByClassName('bmpui-ui-controlbar bmpui-controlbar-top bmpui-container-wrapper bmpui-ui-seekbar')[0].style.visibility = 'hidden';

      // Add an event listener for the 'timechanged' event
      // playerInstance.on('timechanged', function(event) {
      //   // Extract the current playback time from the event
      //   // const currentTime = event.time;
      //   // console.log(currentTime);
      // //  if(currentTime>0)

      //   // Update your UI elements with the current playback time
      // // updateUI(currentTime);
      // });

      // Add an event listener for the 'play' event
      playerInstance.on('play', function(event) {
        // This function will be called when the playback starts
        console.log(props.videoData.timeVideo)
        if(props.videoData.timeVideo > 0 && props.parent === "CotPlayHub" && IsfirstPlay === true){
          playerInstance.pause();
          confirm({
            title: '¿Desea continuar el video desde la ultima visualización?',
            okText: 'Continuar',
            okType: 'success',
            cancelText: 'Cancelar',
            onOk() {
              
              playerInstance.setViewMode("fullscreen");
              playerInstance.seek(props.videoData.timeVideo);
              IsfirstPlay = false;
              playerInstance.play();

            },
            onCancel() {
              playerInstance.setViewMode("fullscreen");
              IsfirstPlay = false;
              playerInstance.seek(0);
              playerInstance.play();
            },
          });
        }
        console.log('Playback started!');
      });

      // Add an event listener for the 'pause' event
      playerInstance.on('paused', function(event) {
        // This function will be called when the playback is paused
        if(props.parent === "CotPlayHub"){
          const currentTime = event.time;

          dispatch(CotplayHubActions.timeMediaHub({
            employeeId: props.employeeId,
            idMultimedia: props.idMultimedia,
            time: currentTime
          }));
        }
        if(props.parent === "Communication" && (props.idCommunication !== null || props.idCommunication !== undefined)){
          const currentTime = event.time;
          dispatch(CommunicationActions.timeQuizMedia({ time: currentTime, idCommunication: props.idCommunication }))
        }
      });


      // playerInstance.on('viewmodechanged',function(event){
      //   if(event.to !== "fullscreen"){
      //     playerInstance.pause()
      //   }
      // });

      // Add an event listener for the 'finished' event
      playerInstance.on('playbackfinished', function(event) {
        // This function will be called when the playback finishes

        if(props.parent === "CotPlayHub"){
          dispatch(CotplayHubActions.finishedMediaHub({
            employeeId: props.employeeId,
            idCourse: props.idCourse
          }));
        }

        if(props.parent === "Communication" && (props.idCommunication !== null || props.idCommunication !== undefined)){
          props.setIsFinished(false);
          dispatch(CommunicationActions.timeQuizMedia({ time: 0, idCommunication: props.idCommunication }))
          
        }
        playerInstance.setViewMode("inline");
      });
    }

    setupPlayer();

    return () => {
      function destroyPlayer() {
        if (player != null) {
          player.destroy();
          setPlayer(null);
        }
      }

      destroyPlayer();
    }
  }, [])

  return ( 
    <div>
      <div style={{visibility: showPlayer ? 'hidden' : 'visible' }}> Cargando video...</div> 
      <div id='player' style={{visibility: showPlayer ? 'visible' : 'hidden' }}  ref={playerDiv}/>
      
    </div>
  )
}

export default MediaPlayer;
